import { Container, Row, Col, Pagination } from "react-bootstrap";
import { useSearchParams } from "react-router-dom";
import Loader from "../Components/Loader";
import Message from "../Components/Message";
import Product from "../Components/Product";
import { useGetProductsQuery } from "../slices/productsApiSlice";
import Meta from "../Components/Meta";

export default function ResultsScreen() {
  const [sp, setSp] = useSearchParams();
  // Send EVERYTHING to the API; the backend already supports make/model/year/category/etc.
  const query = { ...Object.fromEntries(sp.entries()) };
  const currentPage = Number(query.page || query.pageNumber || 1);
  query.pageNumber = currentPage;
  const keyword = (query.keyword || "").trim();

  const { data, isLoading, error } = useGetProductsQuery(query);
  const products = data?.products ?? [];
  const pages = data?.pages ?? 1;

  const handlePageChange = (nextPage) => {
    setSp((prev) => {
      const params = new URLSearchParams(prev);
      params.delete("pageNumber");
      if (nextPage === 1) params.delete("page");
      else params.set("page", String(nextPage));
      return params;
    });
  };

  return (
    <Container className="py-4">
      <Meta title="Product Search Results | KCC Parts" noindex />
      <h1 className="mb-3">Results</h1>
      <div className="text-muted mb-4">
        {keyword ? `Search: ${keyword}` : ""}
        {query.make ? `${keyword ? " • " : ""}${query.make}` : ""}
        {query.model ? ` • ${query.model}` : ""}
        {query.year ? ` • ${query.year}` : ""}
        {query.category ? ` • ${query.category}` : ""}
      </div>

      {isLoading && <Loader />}
      {error && (
        <Message variant="danger">
          {error?.data?.message || error.error}
        </Message>
      )}

      <Row>
        {products.map((p) => (
          <Col key={p._id} sm={12} md={6} lg={4} xl={3}>
            <Product product={p} />
          </Col>
        ))}
        {!isLoading && !error && products.length === 0 && (
          <Col>
            <Message>No products found.</Message>
          </Col>
        )}
      </Row>
      {pages > 1 && (
        <div className="d-flex justify-content-center mt-4">
          <Pagination>
            {[...Array(pages).keys()].map((x) => {
              const page = x + 1;
              return (
                <Pagination.Item
                  key={page}
                  active={page === currentPage}
                  onClick={() => handlePageChange(page)}
                >
                  {page}
                </Pagination.Item>
              );
            })}
          </Pagination>
        </div>
      )}
    </Container>
  );
}
